import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { closeApp } from '@redux/slices/workflowSlice'
import { claimAcceptedSelector, resetSubmitError } from '@redux/slices/claimSubmitSlice'
import { injectDataAttributes } from '@utils/dataAttributes'
import { useAppTranslation } from '@hooks/useAppTranslation'
import { Button } from '@components/ui-css/Button/Button'
import { Modal, ModalActionContainer, ModalContent, ModalFooter, ModalHeader } from '@components/ui-css/Modal/Modal'

export const ClaimAcceptedListener: React.FC = () => {
  const dispatch = useDispatch()
  const accepted = useSelector(claimAcceptedSelector)
  const { t } = useAppTranslation({ keyPrefix: 'SubmitSuccess' })

  const onProceedToCheckout = () => {
    dispatch(resetSubmitError())
    dispatch(closeApp())
  }

  return (
    <Modal open={accepted} onClose={onProceedToCheckout}>
      <ModalHeader>{t('accepted.title')}</ModalHeader>
      <ModalContent>
        <span dangerouslySetInnerHTML={{ __html: t('accepted.message') }}></span>
      </ModalContent>
      <ModalFooter>
        <ModalActionContainer>
          <Button onClick={onProceedToCheckout} {...injectDataAttributes('modal.proceedToCheckout')}>
            {t('accepted.proceed-cta')}
          </Button>
        </ModalActionContainer>
      </ModalFooter>
    </Modal>
  )
}
